// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".namespace-pod-rule[data-v-123cca60]{display:table;width:100px;padding:0,10px,0,0;text-align:center}.namespace-pod-rule .label[data-v-123cca60]{display:table-cell;vertical-align:middle}", ""]);
// Exports
module.exports = exports;
